import React, { FC, useEffect } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { SharedSlideout, SharedSlideoutProps } from 'ps-shared-ui/v3/Slideout';
import updateRoute from '../Utils/updateRoute';

interface SharedSlideoutWithRouterProps extends SharedSlideoutProps, RouteComponentProps {
  endpoint?: string;
}

const SharedSlideoutWithRouter: FC<SharedSlideoutWithRouterProps> = (props: SharedSlideoutWithRouterProps) => {
  const { endpoint, handleCloseSlideout, history, location, isOpen } = props;

  useEffect(() => {
    if (endpoint) {
      updateRoute(location.pathname, endpoint, history, isOpen);

      if (isOpen) {
        window.addEventListener('popstate', handleCloseSlideout);
      } else {
        window.removeEventListener('popstate', handleCloseSlideout);
      }
    }
  }, [isOpen]);

  return (
    <SharedSlideout {...props} />
  );
}

export default withRouter(SharedSlideoutWithRouter);